module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/back_button-9156936ef02b3104964ab4bf53763c09.svg";